const dev = 'https://cxx.cardsvault.net/app'
// const dev = 'http://8.130.92.97:8080/app'
// const dev = 'https://preview.cardsvault.net/app'
//线上：  https://cxx.cardsvault.net/app
//本地：  http://8.130.92.97:8080/app
// 测试:  https://javaapi.cardsvault.net:8060/app


export default dev